import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useApi, useFetch, useMe, errMsg, fmtDate } from "../lib/api";
import { Btn, Card, Empty, PageHeader, StateBadge } from "../components/common";

export default function Followups() {
  const api = useApi();
  const { isAdmin } = useMe();
  const { data, reload } = useFetch("/followups");
  const { data: s } = useFetch("/settings");
  const now = new Date().toISOString();
  const cancel = async (id) => { try { await api.post(`/followups/${id}/cancel`); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div>
      <PageHeader title="Follow-ups" subtitle={`Sequence after an approved first email: day ${s?.outreach.followup_days.join(", day ") || "…"} (edit in Settings). Due follow-ups become drafts awaiting your approval.`} />
      <Card>
        {!data?.length ? <Empty text="No follow-ups scheduled. They are created automatically when an approved email is sent." testid="followups-empty" /> : (
          <table className="dm-table w-full"><thead><tr><th>Company</th><th>To</th><th>Step</th><th>Due</th><th>Status</th><th>Stop reason</th><th></th></tr></thead>
            <tbody>{data.map((f) => (
              <tr key={f.id} data-testid={`followup-${f.id}`} className={f.status === "scheduled" && f.due_at <= now ? "bg-amber-50" : ""}>
                <td><Link className="text-blue-700 hover:underline" to={`/admin/opportunities/${f.opportunity_id}`}>{f.company}</Link></td>
                <td className="font-mono text-xs">{f.to_email}</td><td>{f.step}</td><td className="text-xs">{fmtDate(f.due_at)}</td>
                <td><StateBadge s={f.status} /></td><td className="text-xs">{f.stop_reason || ""}</td>
                <td>{isAdmin && ["scheduled", "draft_ready"].includes(f.status) && <Btn variant="ghost" className="h-7 text-xs" onClick={() => cancel(f.id)} data-testid={`followup-cancel-${f.id}`}>Stop</Btn>}</td>
              </tr>))}</tbody></table>)}
      </Card>
    </div>
  );
}
